import React from "react";
import useObjectInput from "../../../../hooks/useObjectInput";
import "./index.css";

// every node header has two tabs, details and rules
const GOITabs = ({ activeTab, setActiveTab, data }) => {
  const { findErrorObjectById, highlightData } = useObjectInput();

  const tabNames = ["details", "rules"];

  // close the tab if a user clicks on the same tab, otherwise open the tab
  const handleTab = (e) => {
    if (activeTab === e.target.textContent) {
      setActiveTab("");
    } else {
      setActiveTab(e.target.textContent);
    }
  };

  const allRules = [...data.rules.classRules, ...data.rules.attributeRules];

  const getStyles = (tabName) => {
    if (tabName !== "rules") {
      return {};
    }

    const { uniqueId, dependenciesId } = highlightData || {};
    const errorObject = findErrorObjectById(uniqueId);

    const ruleMatches = allRules.some(
      (rule) =>
        rule.name === errorObject?.name &&
        data.id === errorObject?.errorAtObjectId
    );

    const dependenciesMatch = dependenciesId?.includes(data.id);

    return ruleMatches || dependenciesMatch
      ? { backgroundColor: "#9814ac", color: "white" }
      : {};
  };

  const tabClassName = (tabName, index) =>
    `goi-header-section-tablinks ${activeTab === tabName ? "active" : ""} ${
      index % 2 === 0 ? "goi-header-section-no-border" : ""
    }`;

  return (
    <div className="goi-header-section-tab" id={data.id}>
      {tabNames.map((tabName, index) => (
        <button
          key={tabName}
          className={tabClassName(tabName, index)}
          onClick={handleTab}
          style={getStyles(tabName)}
        >
          {tabName}
        </button>
      ))}
    </div>
  );
};

export default GOITabs;
